import { apolloProvider } from '@/apollo-provider.js'
import { QUERY_LIST_INDUSTRIES } from './graphql'
import cloneDeep from 'lodash/cloneDeep'
import { microservicesUrls } from '@/plugins/microservices/microservices'

export default {
  async fetchIndustries({ commit }) {
    await apolloProvider.defaultClient
      .query({
        query: QUERY_LIST_INDUSTRIES,
        context: {
          uri: microservicesUrls['fedGateway'],
        },
        variables: {
          pagination: {
            page: 1,
            pageSize: 10,
            search: null,
            sort: null,
            sortDirection: 'DESC',
          },
        },
        fetchPolicy: 'no-cache',
      })
      .then(({ data }) => {
        commit('SET_INDUSTRIES', cloneDeep(data.listIndustries.data))
      })
  },
}
